import jwtAxios from '@crema/services/auth/jwt-auth';

/**
 * Profile API Service
 * Handles all profile-related API calls
 */
class ProfileApiService {
  /**
   * Get comprehensive user profile data
   * @returns {Promise<Object>} Profile data response
   */
  async getProfile() {
    try {
      const response = await jwtAxios.get('/api/auth/profile');
      return response.data;
    } catch (error) {
      console.error('Profile API Error:', error);
      throw error;
    }
  }

  /**
   * Update user profile
   * @param {Object} profileData - Profile data to update
   * @returns {Promise<Object>} Update response
   */
  async updateProfile(profileData) {
    try {
      const response = await jwtAxios.patch('/api/auth/me', profileData);
      return response.data;
    } catch (error) {
      console.error('Profile Update Error:', error);
      throw error;
    }
  }

  /**
   * Send verification email
   * @param {number} userId - User ID
   * @returns {Promise<Object>} Verification email response
   */
  async sendVerificationEmail(userId) {
    try {
      const response = await jwtAxios.post(
        `/api/users/${userId}/send-verification-email`,
      );
      return response.data;
    } catch (error) {
      console.error('Verification Email Error:', error);
      throw error;
    }
  }
}

// Create and export a singleton instance
const profileApi = new ProfileApiService();
export default profileApi;
